import React, { useRef } from 'react';

import useElementWidth from '../useElementWidth';


export default function Spark({ points, large = false }: { points: Array<number | null>; large?: boolean }) {
  const HEIGHT = large ? 72 : 40;
  const ref = useRef<SVGSVGElement>(null);
  const width = useElementWidth(ref) || 160;
  const known = points.filter((point): point is number => point !== null);
  if (known.length < 2) return <svg aria-hidden className="spark" ref={ref} />;
  const low = Math.min(...known);
  const high = Math.max(...known);
  const span = high - low || 1;
  const x = (index: number) => 3 + (index / (points.length - 1)) * (width - 8);
  const y = (value: number) => HEIGHT - 4 - ((value - low) / span) * (HEIGHT - 10);
  const path = points
    .map((point, index) => (point === null ? null : `${x(index).toFixed(1)},${y(point).toFixed(1)}`))
    .filter(Boolean)
    .join(' ');
  const last = points[points.length - 1];
  return (
    <svg aria-hidden className="spark" height={HEIGHT} ref={ref} viewBox={`0 0 ${width} ${HEIGHT}`}>
      <polyline fill="none" points={path} stroke="var(--chart-1)" strokeLinejoin="round" strokeWidth="1.5" />
      {last !== null ? <circle cx={x(points.length - 1)} cy={y(last)} fill="var(--chart-1)" r="2.6" /> : null}
    </svg>
  );
}
